// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"94036a45","500":"7659fac8","604":"f694a8d4","645":"a42bd9f1","715":"38d76b8b","787":"6b95572a","990":"e431b468"}[chunkId] + ".chunk.js";
};